// extracted by mini-css-extract-plugin
module.exports = {"minBodyHeight":"style_minBodyHeight__28j3s"};